<fcom-modal
  [(open)]="modalOpen"
  [title]="'safNotification.infoModal.title' | finLocalization"
  [buttons]="ModalButtons.CLOSE"
  (close)="closeModal.emit()"
>
  @if (safArticle$ | async; as article) {
    @if (article.picture; as imageData) {
      <div data-testid="sustainability-image" class="image-wrapper relative flex">
        <fin-content-image [imageData$]="imageData | finToObservable" [aspectRatio$]="aspectRatio$" />
      </div>
    }

    <cms-rich-text
      [attr.data-testid]="'item-teaser-title-' + article.contentId"
      [extraClasses]="'font-body-2 font-body-small mr-large-b ' + article.subjectTaxonomyTags?.join(' ')"
      [headerLevel]="4"
      [scaleImage]="false"
      [content$]="safArticle$"
    />
  }
</fcom-modal>
